<template>
	<b-container class="pt-4">
		<h1>Videodemonstration og videokurser</h1>
		<b-row>
			<b-col md="8">
				<p>Du er sikkert nysgerrig efter at se SkvizBiz i funktion. Det forstår vi godt. Derfor har vi lavet en
				række intro-videoer om programmet, hvor du kan se hvordan forskellige funktioner virker. Hvis du ser
				intro-videoerne, vil du få et godt indblik i hvordan du som vinduespudser eller rengøringsmand med
				SkvizBiz kan spare tid på ruteplanlægning, kundestyring, afstemning af indbetalinger, regnskab og andet
				kontorarbejde.</p>
				<p>Vi har også lavet mere detaljerede kursusvideoer om nogle af programmets funktioner. Alle videoerne
				er lavet som en hjælp til både nye og erfarne brugere af programmet, men selvfølgelig er der også masser
				af funktioner i programmet, som vi ikke kan dække i disse videoer.
					<b-link to="/tilmelding">
						Bestil en gratis 30-dages demo-konto
						allerede i dag for selv at se, hvor meget programmet kan.
					</b-link>
				</p>
				<p>Du kan vælge mellem alle videoerne i listerne herunder. Videoerne åbnes i et nyt vindue.</p>
			</b-col>
			<b-col md="4">
				<div class="position-relative has_video_icon clearfix" :href="video_collections['Introduktion'][0].link" :title="video_collections['Introduktion'][0].name" onclick="window.open(this.href, 'PopupWindow', 'status=yes,resizeable=yes,width=1280,height=745');return false;" style="cursor: pointer; overflow: visible;">
					<lazy-image nolazy :src="require('~/assets/images/video_example.jpg')" align="right" class="img-fluid img-thumbnail shadowed" width="720" height="405" />
					<fa :icon="fabYoutube" size="3x" fixed-width class="video_icon" />
				</div>
			</b-col>
		</b-row>
		<b-card-group deck>
			<b-card no-body v-for="(video_colletion, name) in video_collections" :key="name" :header="name" header-tag="h5">
				<b-list-group flush>
					<b-list-group-item v-for="video in video_colletion" :key="video.link">
						<b-link :href="video.link" target="popup" rel="noopener" onclick="window.open(this.href, 'PopupWindow', 'status=yes,resizeable=yes,width=1280,height=745');return false;" :title="video.name"><fa :icon="farVideo" fixed-width /> {{ video.name }}</b-link>
					</b-list-group-item>
				</b-list-group>
			</b-card>
		</b-card-group>
		<b-row>
			<b-col>
				<p><strong>Bemærk: </strong>Da vi hele tiden arbejder med at forbedre programmet, kan enkelte funktioner være ændret lidt i forhold til da vi lavede videoerne, og designet kan være opdateret.</p>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import {
	farVideo, 
	fabYoutube
} from "!!fa-icon-loader!~/assets/@fortawesome/fontawesome-pro/metadata/icons.json";
import LazyImage from "~/components/LazyImage";

import {
	BContainer,
	BRow,
	BCol,
	BLink,
	BCardGroup,
	BCard,
	BListGroup,
	BListGroupItem,
} from "bootstrap-vue";

export default {
	components: {
		BContainer,
		BRow,
		BCol,
		BLink,
		BCardGroup,
		BCard,
		BListGroup,
		BListGroupItem,
		
		LazyImage,
		sbSignup: () => import('../components/Signup.vue'),
	},
	data: function() {return{
		show_signup: false,
		signup_loaded: false,
		video_collections: {
			"Introduktion": [
				{link: "https://www.youtube.com/embed/YUK9Bjg1F3g?rel=0", name: "Introduktion til SkvizBiz",},
				{link: "https://www.youtube.com/embed/dXlkI0CwzuU?rel=0", name: "Intro - Sådan opretter du kunder",},
				{link: "https://www.youtube.com/embed/-0DVQKrRujM?rel=0", name: "Intro - Organiser kunderne i ruter",},
				{link: "https://www.youtube.com/embed/tLFkGZaFyAQ?rel=0", name: "Intro - Kalender og udskrift af rute",},
				{link: "https://www.youtube.com/embed/sV690U-MwFE?rel=0", name: "Intro - Åbne ruter og færdigmelding",},
			],
			"Kursus": [
				{link: "https://www.youtube.com/embed/-RHkD3YngWw?rel=0", name: "Kursus - Kundeoversigten",},
				{link: "https://www.youtube.com/embed/j98sxxDiZz4?rel=0", name: "Kursus - Åbne ordrer",},
				{link: "https://www.youtube.com/embed/shMiNQ4jrMw?rel=0", name: "Kursus - Finansmodulet",},
				{link: "https://www.youtube.com/embed/keGDfQpKD5A?rel=0", name: "Kursus - Brug af SMS-modulet",},
				// {link: "https://www.youtube.com/embed/ySP4s0w7tx0?rel=0", name: "Kursus - Betalingsservice",},
				{link: "https://www.youtube.com/embed/Y2h4fYAZLBQ?rel=0", name: "Kursus - Afsend E-faktura",},
				// {link: "https://www.youtube.com/embed/fPAGbpenpGE?rel=0", name: "Kursus - Print Rute Classic",},
				{link: "https://www.youtube.com/embed/xqr8dMEosvY?rel=0", name: "Kursus - Prisjustering",},
			],
			"Gennemgang": [
				{link: "https://www.youtube.com/embed/q_sB4yZ5ThM?rel=0", name: "Gennemgang - Fakturaarkiv",},
				{link: "https://www.youtube.com/embed/581r_J1K2hQ?rel=0", name: "Gennemgang - Indstillinger",},
				{link: "https://www.youtube.com/embed/I63l3pVscxw?rel=0", name: "Gennemgang - Regnskabsudtræk",},
				{link: "https://www.youtube.com/embed/I4Er6q4w1uI?rel=0", name: "Modul - Prisberegner",},
				{link: "https://www.youtube.com/embed/fCkOJs74y8A?rel=0", name: "Kursus - Bilagshåndtering",},
			],
		},
	}},
	computed: {
		farVideo() {return farVideo},
		fabYoutube() {return fabYoutube},
	},
	head: {
		titleTemplate: '%s - Videoer'
	},
}
</script>

<style lang="scss">
	.has_video_icon {
		.video_icon {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%) scale(1);
			color: #ff0000;
			filter: drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 0.05em) drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 0.1em);
			transition: all .1s ease-in-out;
		}
		.shadowed {
			box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
			transition: all .1s ease-in-out;
		}

		&:hover {
			.video_icon {
				transform: translateX(-50%) translateY(-50%) scale(1.1);
				filter: drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 0.05em) drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 0.1em);
			}
			.shadowed {
				box-shadow: 0 .5rem 1rem rgba(0,0,0,.25);
			}
		}

	}
</style>
